import React from "react";

import Navbar from "./navigation";
import "../assets/css/Home.css";
import useDocumentTitle from "./UseDocumentTitle";

import { Footer } from "./Home";
import { ReactComponent as Conversion } from "../assets/img/conversion.svg";
import { ReactComponent as PenToSquare } from "../assets/img/pen-to-square.svg";
import { ReactComponent as GrowthStrategy } from "../assets/img/growth-strategy.svg";

import { ReactComponent as LegacyEstate } from "../assets/img/legacy-estate.svg";

import { ReactComponent as DangerZone } from "../assets/img/danger-zone.svg";
import { ReactComponent as MoneyIncrease } from "../assets/img/money-increase.svg";
import PayPalComponent from "./PayPal";
const ServicesPage: React.FC = () => {
  useDocumentTitle("Services", true);
  return (
    <div className="services-main-container">
      <Navbar />

      <ServiceTopHeader />

      <ServiceMiddleSection />

      <Footer />
    </div>
  );
};

const ServiceTopHeader: React.FC = () => {
  return (
    <div className="services-top-header-container">
      <h3>Learn Defensive Strategies to Shield Your Retirement</h3>
      <p>
        Our expert retirement planning services help you reduce tax burdens,
        maximize savings, and secure a financially stable future. With tailored
        strategies and guidance, you can retire with confidence, knowing your
        money works for you—not the IRS.{" "}
      </p>{" "}
      <div className="big-button-container">
        <a className="big-test-button" href="/quiz">
          Take the Quiz
        </a>
      </div>
    </div>
  );
};
export const ServiceMiddleSection: React.FC = () => {
  return (
    <div className="services-middle-section-container">
      <div className="services-header">
        <h1>Our Services</h1>
      </div>
      <div className="services-middle-section-first-row">
        <ul>
          <li>
            <div className="conversion-wrapper">
              <Conversion className="conversion-icon" />
            </div>
            <h3>Roth Conversion Strategies</h3>
            <p>
              We help clients determine the best approach to convert their
              traditional 401(k) or IRA funds into a Roth IRA—minimizing tax
              liability while maximizing future tax-free income. Our strategies
              ensure a smooth transition with minimal impact on your current
              finances.
            </p>
          </li>
          <li>
            <div className="money-increase-wrapper">
              <MoneyIncrease className="money-increase-icon" />
            </div>
            <h3>Annuity Optimization</h3>
            <p>
              If you have an existing annuity that you have NOT taken income
              from, we can analyze and optimize a strategy to potentially double
              the amount of income received from the annuity.
            </p>
          </li>

          <li>
            <div className="pen-to-square-wrapper">
              <PenToSquare className="pen-to-square-icon" />
            </div>
            <h3>Tax-Free Retirement Planning</h3>
            <p>
              A tax-free retirement requires careful planning. We develop
              customized tax-free income strategies that take advantage of Roth
              IRAs, Roth 401(k)s, and other tax-efficient investment vehicles to
              help you keep more of your money in retirement.
            </p>
          </li>
        </ul>
      </div>

      <div className="services-middle-section-second-row">
        <ul>
          <li>
            <div className="legacy-estate-wrapper">
              <LegacyEstate className="legacy-estate-icon" />
            </div>
            <h3>Legacy & Estate Planning with Roth Accounts</h3>
            <p>
              Roth IRAs can be powerful estate planning tools. We assist clients
              in structuring their Roth accounts to pass wealth tax-free to
              heirs while minimizing estate taxes and complications.{" "}
            </p>
          </li>
          <li>
            <div className="danger-zone-wrapper">
              <DangerZone className="danger-zone-icon" />
            </div>
            <h3>Retirement Account Reviews & Portfolio Risk Assessments</h3>
            <p>
              Our team provides a thorough review of your existing retirement
              accounts and investment risk profile to ensure your portfolio
              aligns with your tax-free retirement goals.{" "}
            </p>
          </li>
          <li>
            <div className="growth-strategy-wrapper">
              <GrowthStrategy className="growth-strategy-icon" />
            </div>
            <h3>Pension Optimization</h3>
            <p>
              Most pensions have limitations. Discover if you can get more money
              from your pension and get it tax free. Potentially, leave your
              pension to your children.
            </p>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default ServicesPage;
